import React from 'react';

import {Text, Anchor} from '@albert-io/atomic';
import {history} from 'client/history';

import TermsFooter from './TermsFooter';
import AccountTypeSelector, {type AccountType} from './AccountTypeSelector';

export default function AccountTypeStep() {
  const goToSignUp = (type: AccountType) => {
    history.pushState(null, `/signup?accountType=${type}`);
  };

  return (
    <div className='flex w-full flex-col items-center justify-center gap-x5'>
      <Text className='text-xxl font-black' data-testid='account-type-step__heading'>
        Get started as a(n)...
      </Text>

      <AccountTypeSelector selectedType={null} onSelect={goToSignUp} />

      <Text className='text-center'>
        Already have an account?{' '}
        <Anchor to='/log-in' className='content-brand'>
          Log in
        </Anchor>
      </Text>

      <TermsFooter />
    </div>
  );
}
